
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge/[casestudyType]",
      function () {
        return require("private-next-pages/knowledge/[casestudyType]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge/[casestudyType]"])
      });
    }
  